"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styleUtilities_1 = require("../../util/styleUtilities");
var globalPadding = 16;
var innerContentSideSpacing = 32;
var spaceBetweenGridColumns = 24;
var topbarHeight = 64;
var spaceBelowTopbar = 16;
var spacing = {
    globalPadding: globalPadding,
    innerContentSideSpacing: innerContentSideSpacing,
    spaceBetweenGridColumns: spaceBetweenGridColumns,
    sideMargins: (0, styleUtilities_1.createSideMargins)(12, 0, innerContentSideSpacing, spaceBetweenGridColumns),
    sideMarginsSkipOneCol: (0, styleUtilities_1.createSideMargins)(12, 1, innerContentSideSpacing, spaceBetweenGridColumns),
    scrollBarPadding: 10,
    topbarHeight: topbarHeight,
    spaceBelowTopbar: spaceBelowTopbar,
    contentTop: globalPadding + topbarHeight + spaceBelowTopbar,
    subSectionPadding: 40,
    mainContentBottomSpacing: 80,
    dialogsBottomSpacing: 64,
    formSectionDefaultMargin: 64,
};
exports.default = spacing;
